export const SUPER_DOMAIN = "seedbox-os.validation.page"
export const INTERCOM_APP_ID = "r124ry7e"